import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function Promise() {
  const promises = ['We show up when we say we will', 'We communicate clearly throughout your entire project', 'We deliver quality work that meets Pennsylvania code standards', 'We leave your property clean and beautiful', 'We stand behind everything we build'];
  return <section className="py-32 bg-navy text-white relative overflow-hidden" data-id="element-338">
      <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1503387762-592deb58ef4e?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] opacity-10 bg-cover bg-center mix-blend-overlay" data-id="element-339"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-navy/50 to-navy" data-id="element-340"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-341">
        <div className="max-w-4xl mx-auto text-center" data-id="element-342">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-343">
            <div className="flex items-center justify-center gap-4 mb-6" data-id="element-344">
              <div className="h-px w-12 bg-gold" data-id="element-345"></div>
              <span className="text-gold font-bold uppercase tracking-widest text-xs" data-id="element-346">
                The Blue Sky Guarantee
              </span>
              <div className="h-px w-12 bg-gold" data-id="element-347"></div>
            </div>
            <h2 className="text-4xl md:text-5xl font-heading font-bold mb-8" data-id="element-348">
              Our Promise To You
            </h2>
            <p className="text-xl text-gray-300 mb-16 font-light" data-id="element-349">
              Every Blue Sky project comes with our complete commitment:
            </p>
          </motion.div>

          <div className="space-y-4 mb-20 max-w-2xl mx-auto text-left" data-id="element-350">
            {promises.map((promise, index) => <motion.div key={index} initial={{
            opacity: 0,
            x: -20
          }} whileInView={{
            opacity: 1,
            x: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: index * 0.1
          }} className="flex items-center gap-6 bg-white/5 backdrop-blur-sm p-6 rounded-xl border border-white/10 hover:bg-white/10 transition-colors duration-300" data-id="element-351">
                <CheckCircle2 className="w-6 h-6 text-gold flex-shrink-0" data-id="element-352" />
                <span className="text-lg font-light tracking-wide" data-id="element-353">
                  {promise}
                </span>
              </motion.div>)}
          </div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.6
        }} className="inline-block border-b border-gold/50 pb-4" data-id="element-354">
            <p className="text-2xl font-heading font-light text-white italic" data-id="element-355">
              Your satisfaction isn't just our goal —{' '}
              <span className="text-gold font-bold not-italic" data-id="element-356">
                it's our standard.
              </span>
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}